const initAutoplay = () => {
  if (document.querySelector('.c-fw-image')) {
    const iframe = document.querySelector('.c-fw-image .c-video__iframe iframe');
    const button = document.querySelector('.c-fw-image .js-video-button');

    if (iframe) {
      if (iframe.getAttribute('src').includes('autoplay=1')) {
        button.click();
      }
    }
  }
};

export default initAutoplay;
